/* eslint-disable */
import React, { Component } from 'react';
import {ToastsContainer, ToastsStore, ToastsContainerPosition}  from 'react-toasts';


import ConfigurationScreenContentPlaylistItem from '../../../containers/ConfigurationScreen/ConfigurationScreenContent/ConfigurationScreenContentPlaylistItem/ConfigurationScreenContentPlaylistItemQuick';
import PlaylistDropDownComponent from '../../../containers/ConfigurationScreen/ConfigurationScreenContent/PlaylistDropDownComponent';
import SongsDropDownComponent from '../../../containers/ConfigurationScreen/ConfigurationScreenContent/SongsDropDownComponent';
import MConfig      from './../../../moramma-config.json';
import Aux from '../../../hoc/Aux';
import ReactTooltip from 'react-tooltip';
import Classes from './QuickActionModal.css';
import axios        from 'axios';
import lang from '../../../lang.json';
import TextField from '@material-ui/core/TextField';

class QuickActionModal extends Component {

  state = {
    querySongs: null,
    showLoader: false,
    userData: {},
    roomName: '',
    playlists: [],
    playlistSongs: [],
    selectedPlaylist: null,
    selectedSongItemToPropose: null,
    selectedMinInputValue: 0,
    selectedMaxInputValue: 0,
    inputFromToError: '',
    selectedSongToPropose: 0,
    selectedSongFromToPropose: 0,
    blockActions: 0,
    songs: [],
  }
  

  componentWillReceiveProps(nextProps) {
    this.setState({songs: nextProps.songs})
  }

 async componentWillMount() {
   await this.fetchUserData();
 }

  fetchUserData = async () => {
    const localtoken = localStorage.getItem('API');
    if(!localtoken) {
        return this.setState({ logged: false });
    }

    await axios({
        method: 'post',
        url: `${MConfig['BASE_API']}/react/user`,
        headers: {
            "Authorization" : `Bearer ${localtoken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        data: { token: localtoken }
    }).then(async items => {
        const avialablePlaylists = [];
          if (items.data.data.playlists) {
            items.data.data.playlists.forEach(element => {
              avialablePlaylists.push(element);
            });
          }

        this.setState({ playlists: avialablePlaylists, roomName: items.data.data.location.name, userData: items.data.data.location });
        console.log('ok data');        
    });
  }

  dropDownEventChange = (values) => {
    if (values[0]) {
      if (values[0].songs) {
        this.setState({selectedPlaylist: values[0]});

        const avialablePlaylists = [];
        values[0].songs.forEach(element => {
            avialablePlaylists.push(element.song);
          });

          console.log(avialablePlaylists);
          this.setState({ playlistSongs: avialablePlaylists, selectedSongToPropose: 0, selectedSongFromToPropose: 0});
      }
    }
  };

  proposeSongs = async (songsArr, startIndex, stopIndex) => {
    const localtoken = localStorage.getItem('API');

    if(this.state.blockActions) {
      ToastsStore.warning('Please wait until the previus action will be completed');
      return;
    }

    this.setState({ blockActions: 1});

    if(!localtoken) {
      // err
    }

    let maxValue = 1;
    if(this.state.songs[0]) {
      if(this.state.songs[0].user.name === this.state.roomName) {
        maxValue = +this.state.songs[0].votes;
      } else {
        maxValue = +this.state.songs[0].votes + 1;
      }
    }

    if(maxValue === 0) {
      maxValue = 1;
    }
    
    let i = 0;
    for( i = startIndex; i <= stopIndex; i++) {
      console.log('iterating', i, songsArr[i]);
      await axios({
        method: 'put',
        url: `${MConfig['BASE_API']}/rooms/priority/${this.state.roomName}/songs/${songsArr[i].song.id}/${maxValue}`,
        headers: {
          'Authorization': `Bearer ${localtoken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }).then(() => {
        ToastsStore.success(`${songsArr[i].song.title} proposed.`);
      }).catch(err => {
        if(err.response.status === 404) {
          ToastsStore.error(`'${songsArr[i].song.title}' not available in your country.`);
        }
        else if(err.response.status === 429) {
          ToastsStore.error(`'${songsArr[i].song.title}' already proposed.`);
        }
        else 
        {
          ToastsStore.error(`Unable to propose ${songsArr[i].song.title}.`);
        }
        console.error('proposeAllSongs', err);
      });  
    }
    this.setState({ blockActions: 0});
  }

  proposeSong = async (songItem) => {
    const localtoken = localStorage.getItem('API');

    if(!localtoken) {
      // err
    }

    let maxValue = 1;
    if(this.state.songs[0]) {
      if(this.state.songs[0].user.name === this.state.roomName) {
        maxValue = +this.state.songs[0].votes;
      } else {
        maxValue = +this.state.songs[0].votes + 1;
      }
    }

    if(maxValue === 0) {
      maxValue = 1;
    }

      await axios({
        method: 'put',
        url: `${MConfig['BASE_API']}/rooms/priority/${this.state.roomName}/songs/${songItem.id}/${maxValue}`,
        headers: {
          'Authorization': `Bearer ${localtoken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }).then(() => {
        ToastsStore.success(`${songItem.title} proposed.`);
      }).catch(err => {
        if(err.response.status === 404) {
          ToastsStore.error(`'${songItem.title}' not available in your country.`);
        }
        else if(err.response.status === 429) {
          ToastsStore.error(`'${songItem.title}' already proposed.`);
        }
        else 
        {
          ToastsStore.error(`Unable to propose ${songItem.title}.`);
        }

        console.error('proposeAllSongs', err);
      }); 
    }

    deleteAllSongs = async () => {
      const localtoken = localStorage.getItem('API');
  
      if(!localtoken) {
        // err
      }
        await axios({
          method: 'delete',
          url: `${MConfig['BASE_API']}/rooms/${this.state.roomName}/songs`,
          headers: {
            'Authorization': `Bearer ${localtoken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }).then(() => {
          ToastsStore.info('Done.');
        }).catch(err => {
          console.error('proposeAllSongs', err);
        }); 
      }

  dropDownEventChangeSong = (values) => {
    if (values[0]) {
      console.log(values[0]);
      this.setState({selectedSongToPropose: 1, selectedSongItemToPropose: values[0], selectedSongFromToPropose: 0});
    }
  };

  handleInputMinProposeSong = (e) => {
    const data = e.currentTarget.value;
    if(parseInt(data) > this.state.selectedPlaylist.songs.length) {
      this.setState({inputFromToError: `Valore massimo supeato! Max:${this.state.selectedPlaylist.songs.length}`, selectedSongFromToPropose: 0});
      console.log(`0 attuale ${data}/ max: ${this.state.selectedMaxInputValue}/ min: ${this.state.selectedMinInputValue}`);
     
    } else if(this.state.selectedMaxInputValue !== 0 && parseInt(data) > this.state.selectedMaxInputValue) {
      console.log(`1 attuale ${data}/ max: ${this.state.selectedMaxInputValue}/ min: ${this.state.selectedMinInputValue}`);
      this.setState({inputFromToError: 'Il valore minimo non può essere maggiore del massimo!', selectedSongFromToPropose: 0});
    }else if(parseInt(data) > this.state.selectedMaxInputValue) {
      console.log(`3 attuale ${data}/ max: ${this.state.selectedMaxInputValue}/ min: ${this.state.selectedMinInputValue}`);
      this.setState({inputFromToError: 'Il valore minimo non può essere maggiore del massimo!', selectedSongFromToPropose: 0});
  }else {
      this.setState({selectedMinInputValue: data, inputFromToError: '', selectedSongFromToPropose: 1});
      console.log(`2 attuale ${data}/ max: ${this.state.selectedMaxInputValue}/ min: ${this.state.selectedMinInputValue}`);
     
    }
  }

  handleInputMaxProposeSong = (e) => {
    const data = e.currentTarget.value;
    if(parseInt(data) > this.state.selectedPlaylist.songs.length) {
      this.setState({inputFromToError: `Valore massimo supeato! Max:${this.state.selectedPlaylist.songs.length}`, selectedSongFromToPropose:0});
      console.log(`00 attuale ${data}/ max: ${this.state.selectedMaxInputValue}/ min: ${this.state.selectedMinInputValue}`);

    } else if(this.state.selectedMiInputValue !== 0 && parseInt(data) < this.state.selectedMinInputValue) {

      this.setState({inputFromToError: 'Il valore massimo non può essere maggiore del minimo', selectedSongFromToPropose: 0});
      console.log(`01 attuale ${data}/ max: ${this.state.selectedMaxInputValue}/ min: ${this.state.selectedMinInputValue}`);

    }else if(parseInt(data) <= this.state.selectedMinInputValue) {
      this.setState({inputFromToError: `Valore minimo supeato! Min:${this.state.selectedMinInputValue}`, selectedSongFromToPropose:0});
       console.log(`02 attuale ${data}/ max: ${this.state.selectedMaxInputValue}/ min: ${this.state.selectedMinInputValue}`);
     
    } else {
      this.setState({selectedMaxInputValue: data, inputFromToError: '', selectedSongFromToPropose: 1});
      console.log(`03 attuale ${data}/ max: ${this.state.selectedMaxInputValue}/ min: ${this.state.selectedMinInputValue}`);
    }
  }

  ProposeSingleSong = () => {
    if(this.state.selectedSongItemToPropose) {
      this.proposeSong(this.state.selectedSongItemToPropose);
    }
  }

  ProposeRange = () => {

    if (this.state.selectedMinInputValue === 0) {
      return this.setState({inputFromToError: `Imposta un valore nel 'minimo'!`});
    }
    if (this.state.selectedMaxInputValue === 0) {
      return this.setState({inputFromToError: `Imposta un valore nel 'massimo'!`});
    }
    if(this.state.inputFromToError !== '') {
      return;
    }

    const playlist = this.state.selectedPlaylist;
    const start = this.state.selectedMinInputValue;
    const from = this.state.selectedMaxInputValue
    console.log('pl:', playlist, start-1, from-1);
    this.proposeSongs(playlist.songs, start-1, from-1);
  }

  ProposeHalfPlaylist = () => {
    const playlist = this.state.selectedPlaylist;
    this.proposeSongs(playlist.songs, 0, Math.round((this.state.selectedPlaylist.songs.length - 2) / 2));
  }

  ProposeAllPlaylist = () => {
    const playlist = this.state.selectedPlaylist;
    this.proposeSongs(playlist.songs, 0, (this.state.selectedPlaylist.songs.length - 2));
  }

  printChange = (e) => {
    if (e.target.value === "" || !e.target.value) {
      this.setState({ querySongs: [], showLoader: false });
    } else {
      this.setState({ querySongs: [], showLoader: true });
      this.callAjax(e.target.value);
    }
  }

  playNowSong = (song) => {
    const localtoken = localStorage.getItem('API');
    if (!localtoken) {
      // logger.error('[ManagerScreen|skipSong] Local token not found');
      this.logOut();
    }

    axios({
      method: 'put',
      url: `${MConfig.BASE_API}/rooms/${this.state.roomName}/songs/${song.id}/online`,
      headers: {
        Authorization: `Bearer ${localtoken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: { token: localtoken, user: this.state.roomName }
    }).then(() => {
      // logger.debug('[ManagerScreen|skipSong] song goes online');
      ToastsStore.success('Online now.');
    }).catch(err => {
      ToastsStore.warning('Error');
      console.error('[ManagerScreen|skipSong] error during API/rooms/x/songs/x/online', err);
    });
  }

  callAjax = async (value) => {
    const localtoken = localStorage.getItem('API');
    if (localtoken) {
      axios({
        method: 'get',
        url: `${MConfig['BASE_API']}/deezer/search/track?query="${value}"`,
        headers: {
          'Authorization': `Bearer ${localtoken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }).then((songs) => {
        console.log(songs);
        
        const songList = songs.data.data.slice(0, 50).map((song) => (
          <ConfigurationScreenContentPlaylistItem
            key={song.id}
            title={song.title}
            artist={song.artist.name}
            picture={song.album.cover}
            preview={song.preview}
            eventAddSong={this.proposeSong}
            eventPreviewSong={this.previewSong}
            eventPlayNowSong={this.playNowSong}
            allSong={song}
          />
        ));
        this.setState({ querySongs: songList, showLoader: false });
      });
    }
  }

  previewSong = (link) => {
    window.open(link, "_blank");
  }

  render() {
    return(
        <Aux>
          <div className={Classes.Modal}>
            <div className="container-fluid">
              <div className={`${Classes.TxtCenter}`}>
                <br />
                <h3>{lang[this.props.language].quick_modal_title}</h3>
                <br />
                <div className="d-flex justify-content-center align-self-center">
                <a className={Classes.NoDecoration} onClick={this.deleteAllSongs}  data-tip={lang[this.props.language].quick_modal_delete_allsong_hint}>
                    <div className={Classes.btnOrange}>
                      <p className={Classes.NoSpace}> 
                        <i className="fas fa-exclamation-triangle" />
                        &nbsp;
                        {lang[this.props.language].quick_modal_delete_allsong_btn}
                      </p>
                    </div> 
                  </a>
                 
                  
                  <ReactTooltip />
                </div>
                <br />
                <hr />
              </div>
              <div className="row">
              <div className="col-6">
                {
                  <PlaylistDropDownComponent
                  options={this.state.playlists}
                  placeholder={lang[this.props.language].quick_modal_dropdown_title}
                  eventChange={this.dropDownEventChange}
                  />
                }
              </div>
              <div className="col-6">
                {
                  this.state.selectedPlaylist  ?
                  (
                    <div>
                      <p onClick={this.ProposeHalfPlaylist}><span className={Classes.SpanActionPointer}><i class="fas fa-angle-double-right"></i> {lang[this.props.language].quick_modal_propose_half} {Math.round((this.state.selectedPlaylist.songs.length - 1) / 2)}</span></p>
                      <p onClick={this.ProposeAllPlaylist}><span className={Classes.SpanActionPointer}><i class="fas fa-angle-double-right"></i> {lang[this.props.language].quick_modal_propose_all} {this.state.selectedPlaylist.songs.length}</span></p>
                      {/** 
                      <p><span className={Classes.SpanAction}><i class="fas fa-angle-double-right"></i> Proponi da <input onChange={this.handleInputMinProposeSong} onInput={this.handleInputMinProposeSong} type="number" min="1" max={this.state.selectedPlaylist.songs.length} /> a &nbsp;   
                        <input type="number" min={this.state.selectedMinInputValue} onChange={this.handleInputMaxProposeSong}  max={this.state.selectedPlaylist.songs.length} /> </span></p>
                      {
                        this.state.inputFromToError === '' ? (
                          <p></p>
                        ) : (
                          <p><span className={Classes.SpanActionErr}>{this.state.inputFromToError}</span></p>
                        )
                      }
                      {
                        this.state.selectedSongFromToPropose === 1 ?
                        (
                          <p onClick={this.ProposeRange}><span className={Classes.SpanActionPropose}>Proponi</span></p>
                        ):
                        (
                          ''
                        )
                      }
                      */}
                      <p><span className={Classes.SpanAction}><i class="fas fa-angle-double-right"></i> {lang[this.props.language].quick_modal_propose_single}:</span></p>
                      <SongsDropDownComponent
                        options={this.state.playlistSongs}
                        eventChange={this.dropDownEventChangeSong}
                      />
                      {
                        this.state.selectedSongToPropose === 1 ? (
                          
                          <p onClick={this.ProposeSingleSong}><br /><span className={Classes.SpanActionPropose}>{lang[this.props.language].quick_modal_propose_btn}</span></p>
                        ) : (
                          ''
                        )
                      }
                    </div>
                  ) : (
                    ''
                  )
                }
              </div>
            </div>  
             
            <br />
                <hr />
            <div className="row">
              <div className="col-6">
                <TextField
                    error={this.state.txtNameError}
                    helperText={this.state.txtNameError ? 'Almeno 3 caratteri..' : ''}
                    label={lang[this.props.language].confscreen_playlist_edit_txt_search_song}
                    type="text"
                    name="name"
                    autoComplete="autocompl"
                    margin="normal"
                    variant="outlined"
                    onKeyUp={this.printChange.bind(this)}
                    className={Classes.SearchBox}
                  />
              </div>
              <div className="col" />
            </div>  
            <div className="row">
            {
              !this.state.querySongs ? (
                ''
              ): (
                <div className={`col ${Classes.NestedScroll}`}>
                  {this.state.querySongs}
                </div>
              )
            }
            </div>
          </div>
          </div>
          <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT}/>  
        </Aux>
    );
  }
}

export default QuickActionModal;
